export const routes = {
	home:'/',
};
